export default "__VITE_ASSET__Dx$Cf_Ko__"